import easy from "./easy/zhTW";

export default {
    easy: easy
}
